export default __webpack_public_path__ + "static/media/GuessJobs2_21.bb8c30dc.png";